var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_9773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.82263 1.6925H20.1513",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82263 9.39514H20.1513",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82263 17.0977H20.1513",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69261 11.0877C2.62742 11.0877 3.38523 10.3299 3.38523 9.39513C3.38523 8.46032 2.62742 7.70251 1.69261 7.70251C0.757809 7.70251 0 8.46032 0 9.39513C0 10.3299 0.757809 11.0877 1.69261 11.0877Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69261 3.38523C2.62742 3.38523 3.38523 2.62742 3.38523 1.69261C3.38523 0.757809 2.62742 0 1.69261 0C0.757809 0 0 0.757809 0 1.69261C0 2.62742 0.757809 3.38523 1.69261 3.38523Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69261 18.7903C2.62742 18.7903 3.38523 18.0324 3.38523 17.0976C3.38523 16.1628 2.62742 15.405 1.69261 15.405C0.757809 15.405 0 16.1628 0 17.0976C0 18.0324 0.757809 18.7903 1.69261 18.7903Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_9773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8382,
    height: 18.796,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.c8a4eb0d87a09604c0ddcaa8b14f7477.svg";
export { ForwardRef as ReactComponent };